import { z } from "zod";

import { RelatedEntityKey } from "./RelatedEntityKey";

export const RelatedEntities = z.object({
  totalCount: z.number(),
  counts: z.record(RelatedEntityKey, z.number()),
  urls: z.record(RelatedEntityKey, z.string()),
});

export type RelatedEntities = z.infer<typeof RelatedEntities>;
